import {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {System} from 'interfaces/System';
import SectionSelect from './SectionSelect';

type Props = {
  systems: System[];
  systemId?: number;
  onSystemChange: (systemId: number) => void;
  hasSelectedTray: boolean;
  deleteTrayFromSection: () => void;
};

export default function SelectSystem({
  deleteTrayFromSection,
  hasSelectedTray,
  onSystemChange,
  systems,
  systemId
}: Props): ReactElement {
  const {t} = useTranslation('common');

  return (
    <SectionSelect
      id="select-system"
      label={t('common:system')}
      placeholder={t('common:selectSystemPlaceholder')}
      value={systemId ?? null}
      options={systems}
      onChange={onSystemChange}
      hasSelectedTray={hasSelectedTray}
      deleteTrayFromSection={deleteTrayFromSection}
    />
  );
}
